import { getLoginInform } from 'function/login';
import { ROUTER_PATH, ROUTER_NAME } from 'types/const';
import { RETURN_YN } from 'types/type';
import format from 'utils/string/format';

export default function getRoute() {
  const { adminYn } = getLoginInform();
  const routes = [
    {
      name: ROUTER_NAME.sfms.dashboard.parent,
      active: true,
      icon: 'chart-pie',
      children: [
        {
          name: ROUTER_NAME.sfms.dashboard.main,
          to: ROUTER_PATH.sfms.dashboard.main,
          exact: true,
          active: true
        },
        {
          name: ROUTER_NAME.sfms.dashboard.trend,
          to: ROUTER_PATH.sfms.dashboard.trend,
          exact: true,
          active: true
        }
      ]
    },
    {
      name: ROUTER_NAME.sfms.mix.inform,
      active: true,
      icon: 'sitemap',
      children: [
        {
          name: ROUTER_NAME.sfms.rawMaterial.price,
          to: ROUTER_PATH.sfms.rawMaterial.price,
          exact: true,
          active: true
        },
        {
          name: ROUTER_NAME.sfms.rawMaterial.nutrition,
          to: ROUTER_PATH.sfms.rawMaterial.nutrition,
          exact: true,
          active: true
        },
        {
          name: ROUTER_NAME.sfms.product.output,
          to: ROUTER_PATH.sfms.product.output,
          exact: true,
          active: true
        },
        {
          name: ROUTER_NAME.sfms.mix.output,
          to: ROUTER_PATH.sfms.mix.output,
          exact: true,
          active: true
        }
      ]
    },
    {
      name: ROUTER_NAME.sfms.mix.insert,
      active: true,
      icon: 'inbox',
      children: [
        {
          name: ROUTER_NAME.sfms.mix.ratio,
          to: ROUTER_PATH.sfms.mix.ratio,
          exact: true,
          active: true
        },
        {
          name: ROUTER_NAME.sfms.product.nutrition,
          to: ROUTER_PATH.sfms.product.nutrition,
          exact: true,
          active: true
        },
        {
          name: ROUTER_NAME.sfms.monitoring,
          to: ROUTER_PATH.sfms.monitoring,
          exact: true,
          active: true
        }
      ]
    },
    {
      name: ROUTER_NAME.sfms.report.parent,
      active: true,
      icon: 'file-alt',
      children: [
        {
          name: ROUTER_NAME.sfms.report.mix.plan,
          to: format(ROUTER_PATH.sfms.report.list, { type: 1 }),
          active: true
        },
        {
          name: ROUTER_NAME.sfms.report.mix.compare,
          to: format(ROUTER_PATH.sfms.report.list, { type: 2 }),
          active: true
        },
        {
          name: ROUTER_NAME.sfms.report.price.rawMaterial,
          to: format(ROUTER_PATH.sfms.report.list, { type: 3 }),
          active: true
        },
        {
          name: ROUTER_NAME.sfms.report.price.product,
          to: format(ROUTER_PATH.sfms.report.list, { type: 4 }),
          active: true
        },
        {
          name: ROUTER_NAME.sfms.report.price.prediction,
          to: format(ROUTER_PATH.sfms.report.list, { type: 5 }),
          active: true
        },
        {
          name: ROUTER_NAME.sfms.report.iomc,
          to: format(ROUTER_PATH.sfms.report.list, { type: 6 }),
          active: true
        },
        {
          name: ROUTER_NAME.sfms.report.analysis.product,
          to: format(ROUTER_PATH.sfms.report.list, { type: 7 }),
          active: true
        },
        {
          name: ROUTER_NAME.sfms.report.analysis.quality,
          to: format(ROUTER_PATH.sfms.report.list, { type: 8 }),
          active: true
        }
      ]
    },
    {
      name: ROUTER_NAME.board.parent,
      active: true,
      icon: 'clipboard-check',
      children: [
        {
          name: ROUTER_NAME.board.notice,
          to: ROUTER_PATH.board.notice.list,
          active: true
        },
        {
          name: ROUTER_NAME.board.rawMaterial,
          to: ROUTER_PATH.board.rawMaterial.list,
          active: true
        },
        {
          name: ROUTER_NAME.board.file,
          to: ROUTER_PATH.board.file,
          exact: true,
          active: true
        },
        {
          name: ROUTER_NAME.board.qna,
          to: ROUTER_PATH.board.qna.list,
          active: true
        }
      ]
    },
    {
      name: ROUTER_NAME.standard.parent,
      active: true,
      icon: 'info-circle',
      children: [
        {
          name: ROUTER_NAME.standard.code.default,
          to: ROUTER_PATH.standard.code.default,
          exact: true,
          active: true
        },
        {
          name: ROUTER_NAME.standard.code.mix,
          to: ROUTER_PATH.standard.code.mix,
          exact: true,
          active: true
        },
        {
          name: ROUTER_NAME.standard.code.rawMaterial,
          to: ROUTER_PATH.standard.code.rawMaterial,
          exact: true,
          active: true
        },
        {
          name: ROUTER_NAME.standard.code.product,
          to: ROUTER_PATH.standard.code.product,
          exact: true,
          active: true
        }
      ]
    }
  ];

  // 관리자인 경우 관리자 메뉴 추가
  if (adminYn === RETURN_YN.Y) {
    routes.push({
      name: ROUTER_NAME.admin.parent,
      active: true,
      icon: 'tasks',
      children: [
        {
          name: ROUTER_NAME.admin.children,
          to: ROUTER_PATH.admin.list,
          active: true
        }
      ]
    });
  }

  return routes;
}
